/* Feedback tones and haptics. Silent-safe: every call is wrapped. */

import { state } from './state.js';

let actx;
export function beep(kind){
  if(!state.sound)return;
  try{
    actx=actx||new (window.AudioContext||window.webkitAudioContext)();
    if(actx.state==="suspended")actx.resume();
    const o=actx.createOscillator(),g=actx.createGain(),t=actx.currentTime;
    o.type="triangle";o.connect(g);g.connect(actx.destination);
    const seq={ok:[620,880],no:[200,150],win:[660,880,1320],tick:[440],up:[740,988,1244]}[kind]||[440];
    seq.forEach((f,i)=>o.frequency.setValueAtTime(f,t+i*0.075));
    g.gain.setValueAtTime(.075,t);
    g.gain.exponentialRampToValueAtTime(.0008,t+.08*seq.length+.14);
    o.start(t);o.stop(t+.08*seq.length+.18);
  }catch(e){}
}
export function buzz(ok){try{navigator.vibrate&&navigator.vibrate(ok?14:[0,26,36,26]);}catch(e){}}
export function fx(ok){beep(ok?"ok":"no");buzz(ok);}
